export default "__VITE_ASSET__fAZvE0Sz__"